<template>
  <div class="items-list-root">
    <div
        class="items-list-loading"
        v-show="loading && totalLoading == 1"
    >
      <Loading
          type="line"
          :center="false"
      />
      <AnimatedPhrase
          :phrases="['Aguarde...', 'Estamos carregando os produtos...', 'Isso pode levar alguns segundos...']"
      />
    </div>

    <div v-if="showMissingPeriodOnly">
      <br/>
      <Alert type="warning">
        <span>É necessário cadastrar o período de locação.</span>
      </Alert>
    </div>

    <ItemsRentCreate
        v-show="totalLoading > 1 && !showMissingPeriodOnly"
        :rent="rent"
        :operational="operational"
        :kitId="itemSelected.kitId"
        :kitName="itemSelected.kitRentName || itemSelected.productFullName || ''"
        :itemsRentId="itemSelected.id"
        :kitOrAcessory="kitOrAccessory"
        v-model="selectedPeriod"
        :itemsRent="itemSelected"
        :changed="onPeriodChanged"
    />

    <ItemKitOrAccessoryList
        v-if="!showMissingPeriodOnly && showKitOrAccessoryList"
        :kitOrAcessory="kitOrAccessory"
        :rent="rent"
        :itemRent="itemSelected"
        :operational="operational"
        :back="closeKitOrAccessoryList"
    />

    <div v-else-if="!showMissingPeriodOnly">
      <div class="items-list-main">
        <ItemsRentActionBar
            :rent="rent"
            :selectedPeriod="selectedPeriod"
            :withoutGroupStructure="withoutGroupStructure"
            :totalLoading="totalLoading"
            :loading="loading"
            :showGroups="showGroups"
            :totalProducts="totalProducts"
            @add-group="addGroup"
            @open-manage-groups="openManageGroups"
            @open-templates="showGroupTemplateModal = true"
        />

        <div v-if="totalLoading > 1" class="items-search-wrap">
          <input
            v-model="searchQuery"
            class="items-search-input"
            type="text"
            placeholder="Pesquisar..."
          />
        </div>

        <ItemsRentGroupTable
            v-if="totalLoading > 1"
            :rent="rent"
            :items.sync="items"
            :searchQuery="searchQuery"
            :loading="loading"
            :operational="operational"
            :selectAll.sync="selectAll"
            :withAccessory.sync="withAccessory"
            :withOnlyStock.sync="withOnlyStock"
            :withoutGroupStructure="withoutGroupStructure"
            :totalLoading="totalLoading"
            :editing="editing"
            @select-all-changed="onSelectAllChanged"
            @filter-changed="getAll"
            @start-edit-group="onStartEditGroup"
            @commit-edit-group="onCommitEditGroup"
            @add-subgroup="onAddSubgroup"
            @remove-group="onRemoveGroup"
            @start-edit-subgroup="onStartEditSubgroup"
            @commit-edit-subgroup="onCommitEditSubgroup"
            @remove-subgroup="onRemoveSubgroup"
            @add-product-to-subgroup="addProductToSubgroup"
            @drag-end-masters="onDragEndMasters"
            @drag-end-subgroups="onDragEndSubgroups"
            @drag-change-product="onDragChangeProduct"
            @drag-end-products="onDragEndProducts"
        />
      </div>
    </div>

    <BottomActionsBar
        v-if="!showMissingPeriodOnly"
        :selected="selected"
        @close="addSelected([])"
    >
      <ActionsSelected
          :selected="selected"
          :actions="actionsOptions"
      />
    </BottomActionsBar>

    <ItemsRentModalSet
        :operational="operational"
        :modal="modal"
        :itemSelected="itemSelected"
        :showModalGroup="showModalGroup"
        :showGroupTemplateModal.sync="showGroupTemplateModal"
        :showTemplateChoice="showTemplateChoice"
        :templateEditItem="templateEditItem"
        :importedTemplate.sync="importedTemplate"
        :itemsForDraggable="itemsForDraggable"
        :templateEditItems="templateEditItems"
        :selectedPeriod="selectedPeriod"
        :showListKitOrAccessory="showKitOrAccessoryList"
        :kitOrAccessory="kitOrAccessory"
        @hide-change-group-modal="showModalGroup = false"
        @hide-groups="onHideGroups"
        @template-chosen="onTemplateChosen"
        @create-template="openCreateTemplateModal"
        @edit-template="openEditTemplateModal"
        @close-template-modal="closeCreateTemplateModal"
        @apply-template="applyTemplate"
        @modal-closed="getAll"
    />

    <ConfirmDelete
        :visible="deleteConfirm.visible"
        :type="deleteConfirm.type"
        :deleteProducts.sync="deleteConfirm.deleteProducts"
        @close="closeDeleteConfirm"
        @confirm="confirmDeleteTarget"
    />
  </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import AnimatedPhrase from "@nixweb/nixloc-ui/src/component/layout/AnimatedPhrase";
import BottomActionsBar from "@nixweb/nixloc-ui/src/component/layout/BottomActionsBar.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ActionsSelected from "@nixweb/nixloc-ui/src/component/shared/actions/ActionsSelected.vue";

import ConfirmDelete from "./items-rent/ConfirmDelete.vue";
import ItemKitOrAccessoryList from "./ItemKitOrAccessoryList.vue";
import ItemsRentCreate from "./ItemsRentCreate.vue";
import ItemsRentActionBar from "./items-rent/ItemsRentActionBar.vue";
import ItemsRentGroupTable from "./items-rent/ItemsRentGroupTable.vue";
import ItemsRentModalSet from "./items-rent/ItemsRentModalSet.vue";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "ItemsRentList",
  components: {
    AnimatedPhrase,
    ActionsSelected,
    BottomActionsBar,
    Alert,
    ConfirmDelete,
    Loading,
    ItemsRentCreate,
    ItemKitOrAccessoryList,
    ItemsRentActionBar,
    ItemsRentGroupTable,
    ItemsRentModalSet,
  },
  props: {
    rent: {type: Object, required: true},
    operational: {type: Boolean, default: false},
  },
  data() {
    return {
      selectedPeriod: {},
      showGroups: false,
      selectAll: false,
      items: [],
      searchQuery: "",
      withAccessory: false,
      withOnlyStock: false,
      itemSelected: {},
      totalLoading: 1,
      loading: true,
      showModalGroup: false,
      showKitOrAccessoryList: false,
      showTemplateChoice: false,
      showGroupTemplateModal: false,
      importedTemplate: null,
      templateEditItem: null,
      kitOrAccessory: "",
      modal: {
        title: "Modal",
        width: 500,
        height: 500,
        component: "",
      },
      editing: {
        type: null,
        masterIndex: null,
        subgroupIndex: null,
        target: null,
        value: "",
      },
      deleteConfirm: {
        visible: false,
        type: null,
        master: null,
        masterIndex: null,
        subgroup: null,
        subgroupIndex: null,
        deleteProducts: false,
      },
      baseParams: {
        search: undefined,
        filter: "contains",
        currentPage: 1,
        totalPerPage: 20,
      },
      urlGetApi: "/api/v1/rental/items-rent/get-all-by-group",
      urlReorderItemsApi: "/api/v1/rental/items-rent/reorder-items",
      urlCreateUpdateGroup:
          "/api/v1/rental/group-subgroup-rent/create-update-group-selector",
      urlCreateUpdateSubgroup:
          "/api/v1/rental/group-subgroup-rent/create-update-subgroup-selector",
      urlDeleteGroup: "/api/v1/rental/group-subgroup-rent/delete-group",
      urlDeleteSubgroup: "/api/v1/rental/group-subgroup-rent/delete-subgroup",
      urlReorderedGroup:
          "/api/v1/rental/group-subgroup-rent/reordered-group-selector",
      urlReorderedSubgroup:
          "/api/v1/rental/group-subgroup-rent/reordered-subgroup-selector",
      urlCreateEditOrder:
          "/api/v1/rental/group-subgroup-rent/create-edit-order",
      urlUpdateWithoutGroupSubgroup:
          "/api/v1/rental/rent/update-without-group-subgroup",
      actions: [
        {
          type: "delete",
          showStatusRental: [1, 2, 3],
          showModule: ["rental", "operational"],
          title: "Remover",
          description: "Remover",
          url: "/api/v1/rental/items-rent/delete",
          method: "delete",
        },
        {
          type: "event",
          showStatusRental: [1, 2, 3],
          showModule: ["rental"],
          eventName: "applyDiscount",
          tooltip: "Aplicar Desconto",
          backgroundColor: "#FF4843",
          classIcon: "fa-solid fa-percent",
          description: "Aplicar Desconto",
        },
        {
          type: "event",
          showStatusRental: [1, 2, 3],
          showModule: ["rental", "operational"],
          eventName: "changeGroup",
          tooltip: "Alterar Grupo",
          backgroundColor: "#2563EB",
          classIcon: "fa-solid fa-layer-group",
          description: "Transferência de Grupo",
        },
        {
          type: "event",
          showStatusRental: [1, 2, 3],
          showModule: ["rental"],
          eventName: "recalculateValue",
          tooltip: "Recalcular Valor",
          backgroundColor: "#156EBE",
          classIcon: "fa-solid fa-retweet",
          description: "Recalcular Valor",
        },
        {
          type: "options",
          tooltip: "Status de Faturamento",
          showStatusRental: [2],
          showModule: ["rental"],
          url: "/api/v1/rental/items-rent/change-status-invoice",
          backgroundColor: "#02D1C1",
          classIcon: "fa-solid fa-file-invoice",
          description: "Status de Faturamento",
          method: "put",
          options: [
            {text: "Faturado", value: "invoiced"},
            {text: "Não Faturado", value: "notInvoiced"},
            {text: "Não Fatura (Cancelado)", value: "noInvoice"},
          ],
        },
        {
          type: "options",
          tooltip: "Status de Movimentação",
          showStatusRental: [2],
          showModule: ["operational"],
          url: "/api/v1/rental/items-rent/disable-movement",
          backgroundColor: "#E0800E",
          classIcon: "fa-solid fa-shuffle",
          description: "Status de Movimentação",
          method: "put",
          options: [
            {text: "Reservado", value: "reserved"},
            {text: "Sem Movimentação", value: "noMovement"},
          ],
        },
      ],
    };
  },
  mounted() {
    if (this.operational) {
      this.withAccessory = true;
      this.withOnlyStock = true;
    }
  },
  computed: {
    ...mapState("generic", ["selected"]),
    ...mapState("rent", ["withoutGroupStructure"]),
    ...mapGetters("generic", ["event", "showModal"]),
    showMissingPeriodOnly() {
      return !this.loading && this.totalLoading > 1 && !this.hasValidPeriod();
    },
    actionsOptions() {
      const statusRental = this.rent.statusRental;
      const module = this.operational ? "operational" : "rental";
      return this.actions.filter(
          (action) =>
              Array.isArray(action.showStatusRental) &&
              action.showStatusRental.includes(statusRental) &&
              Array.isArray(action.showModule) &&
              action.showModule.includes(module)
      );
    },
    totalProducts() {
      let total = 0;
      for (const group of this.items) {
        for (const sub of group.subGroups || []) {
          total += (sub.products || []).length;
        }
      }
      return total;
    },
    itemsForDraggable() {
      return (this.items || []).map((master) => ({
        groupId: master.groupId || master.id || "",
        groupOrder: master.groupOrder ?? null,
        groupName: master.groupName || "",
        subGroups: (Array.isArray(master.subGroups)
                ? master.subGroups
                : []
        ).map((sub) => ({
          groupId: sub.groupId || sub.id || "",
          groupOrder: sub.groupOrder ?? null,
          groupName: sub.groupName || "",
          products: Array.isArray(sub.products) ? sub.products : [],
        })),
      }));
    },
    templateEditItems() {
      return this.convertTemplateToDraggableItems(this.templateEditItem);
    },
  },
  methods: {
    ...mapMutations("generic", [
      "addSelected",
      "openModal",
      "hideModal",
      "addEvent",
    ]),
    ...mapMutations("rent", ["setWithoutGroupStructure"]),
    ...mapActions("generic", ["getApi", "postApi", "putApi", "deleteApi"]),

    makeKey(prefix) {
      return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    },
    ensureKey(obj, prefix, idField = "groupId") {
      if (!obj) return obj;
      if (!obj.__key) {
        const base = obj[idField] ? String(obj[idField]) : "";
        obj.__key = base ? `${prefix}-${base}` : this.makeKey(prefix);
      }
      return obj;
    },
    normalizeKeys() {
      (this.items || []).forEach((master) => {
        this.ensureKey(master, "g", "groupId");
        if (Array.isArray(master.subGroups)) {
          master.subGroups.forEach((sub) =>
              this.ensureKey(sub, "sg", "groupId")
          );
        }
      });
    },
    getMasterByKey(master) {
      if (!master) return master;
      const key = master.__key || null;
      const id = master.groupId || master.id || null;
      const found = (this.items || []).find(
          (x) =>
              (key && x.__key === key) ||
              (!key && id && (x.groupId === id || x.id === id))
      );
      if (found) found.__subGroupsRef = found.subGroups || [];
      return found || master;
    },

    hasValidPeriod() {
      return !!(
          this.selectedPeriod &&
          (this.selectedPeriod.showAll ||
              (this.selectedPeriod.period && this.selectedPeriod.period.id))
      );
    },
    handleMissingPeriod() {
      this.loading = false;
      this.items = [];
      this.selectAll = false;
      if (this.totalLoading === 1) this.totalLoading = 2;
    },
    onPeriodChanged() {
      if (!this.hasValidPeriod()) {
        this.handleMissingPeriod();
        return;
      }
      if (this.showKitOrAccessoryList) this.showKitOrAccessoryList = false;
      this.getAll();
    },

    getAll() {
      if (!this.hasValidPeriod()) {
        this.handleMissingPeriod();
        return;
      }
      this.loading = true;
      const params = {
        url: this.urlGetApi,
        obj: {
          ...this.baseParams,
          rentId: this.rent.id,
          periodRentId: this.selectedPeriod.showAll
              ? ""
              : this.selectedPeriod.period.id,
          withOnlyStock: this.withOnlyStock,
          withAccessory: this.withAccessory,
          operational: this.operational,
          noPaginated: true,
        },
      };
      this.getApi(params).then((response) => {
        const data = response.content.data || [];
        this.items = (Array.isArray(data) ? [...data] : []).sort(
            (a, b) => (a.groupOrder || 0) - (b.groupOrder || 0)
        );
        this.normalizeKeys();
        this.loading = false;
        if (this.totalLoading === 1 && !data.length)
          this.showTemplateChoice = true;
        this.totalLoading += 1;
        this.selectAll = false;
      });
    },

    onSelectAllChanged(value) {
      this.addSelected([]);
      if (value) {
        this.items.forEach((group) => {
          (group.subGroups || []).forEach((subgroup) => {
            (subgroup.products || []).forEach((product) => {
              this.selected.push(product.id);
            });
          });
        });
      }
    },

    closeKitOrAccessoryList() {
      this.showKitOrAccessoryList = false;
      this.kitOrAccessory = "";
    },

    openManageGroups() {
      this.showGroups = true;
      this.openModal("groupSubgroup");
    },
    onHideGroups() {
      this.showGroups = false;
      this.hideModal();
      this.getAll();
    },
    addGroup() {
      const nextOrder =
          (this.items || []).reduce(
              (max, g) => Math.max(max, g.groupOrder || 0),
              0
          ) + 1;
      const newGroup = {
        __key: this.makeKey("g"),
        groupId: "",
        groupName: `Novo grupo ${nextOrder}`,
        groupOrder: nextOrder,
        rentId: this.rent.id,
        periodRentId:
            this.selectedPeriod && this.selectedPeriod.period
                ? this.selectedPeriod.period.id
                : null,
        subGroups: [],
      };
      this.postApi({
        url: this.urlCreateUpdateGroup,
        obj: newGroup,
        notNotifyToast: true,
      }).then((response) => {
        if (response && response.content) newGroup.groupId = response.content;
        this.ensureKey(newGroup, "g", "groupId");
      });
      this.items.push(newGroup);
      this.startEditGroup(newGroup, this.items.length - 1);
    },
    onAddSubgroup({master, masterIndex}) {
      if (!master) return;
      const masterRef = this.getMasterByKey(master);
      if (!masterRef.subGroups) this.$set(masterRef, "subGroups", []);
      const nextOrder =
          (masterRef.subGroups || []).reduce(
              (max, s) => Math.max(max, s.groupOrder || 0),
              0
          ) + 1;
      const newSubgroup = {
        __key: this.makeKey("sg"),
        groupId: "",
        groupName: `Novo subgrupo ${nextOrder}`,
        groupOrder: nextOrder,
        groupMasterId: masterRef.groupId || masterRef.id || null,
        products: [],
      };
      this.postApi({
        url: this.urlCreateUpdateSubgroup,
        obj: newSubgroup,
        notNotifyToast: true,
      }).then((response) => {
        if (response && response.content)
          newSubgroup.groupId = response.content;
        this.ensureKey(newSubgroup, "sg", "groupId");
      });
      masterRef.subGroups.push(newSubgroup);
      this.startEditSubgroup(
          newSubgroup,
          masterIndex,
          masterRef.subGroups.length - 1
      );
    },
    onRemoveGroup({master, masterIndex}) {
      this.openDeleteConfirm({type: "group", master, masterIndex});
    },
    onRemoveSubgroup({master, masterIndex, subgroup, subgroupIndex}) {
      this.openDeleteConfirm({
        type: "subgroup",
        master,
        masterIndex,
        subgroup,
        subgroupIndex,
      });
    },
    openDeleteConfirm({type, master, masterIndex, subgroup, subgroupIndex}) {
      this.deleteConfirm = {
        visible: true,
        type,
        master: master || null,
        masterIndex: masterIndex ?? null,
        subgroup: subgroup || null,
        subgroupIndex: subgroupIndex ?? null,
        deleteProducts: false,
      };
    },
    closeDeleteConfirm() {
      this.deleteConfirm = {
        visible: false,
        type: null,
        master: null,
        masterIndex: null,
        subgroup: null,
        subgroupIndex: null,
        deleteProducts: false,
      };
    },
    confirmDeleteTarget() {
      const payload = {...this.deleteConfirm};
      this.closeDeleteConfirm();

      if (payload.type === "group") {
        const id =
            payload.master && (payload.master.groupId || payload.master.id);
        if (!id) {
          if (payload.masterIndex !== null && payload.masterIndex > -1) {
            this.items.splice(payload.masterIndex, 1);
          }
          return;
        }
        const deleteSubgroups = payload.deleteProducts === true;
        const url = `${this.urlDeleteGroup}?id=${id}${
            deleteSubgroups ? "&deleteSubgroups=true" : ""
        }`;
        this.deleteApi({url, obj: {}, notNotifyToast: true}).then(
            (response) => {
              if (response && response.success) {
                this.items = this.items.filter((x) => (x.groupId || x.id) !== id);
              }
            }
        );
        return;
      }

      if (payload.type === "subgroup") {
        const id =
            payload.subgroup && (payload.subgroup.groupId || payload.subgroup.id);
        const masterRef = this.getMasterByKey(payload.master);
        if (!id) {
          if (
              masterRef &&
              masterRef.subGroups &&
              payload.subgroupIndex !== null
          ) {
            masterRef.subGroups.splice(payload.subgroupIndex, 1);
          }
          return;
        }
        const deleteProducts = payload.deleteProducts === true;
        const url = `${this.urlDeleteSubgroup}?id=${id}${
            deleteProducts ? "&deleteProducts=true" : ""
        }`;
        this.deleteApi({url, obj: {}, notNotifyToast: true}).then(
            (response) => {
              if (
                  response &&
                  response.success &&
                  masterRef &&
                  masterRef.subGroups
              ) {
                masterRef.subGroups = masterRef.subGroups.filter(
                    (s) => (s.groupId || s.id) !== id
                );
              }
            }
        );
      }
    },
    addProductToSubgroup(subgroup) {
      this.addEvent({name: "addProductBySubgroup", data: subgroup});
    },

    startEditGroup(target, masterIndex) {
      this.editing = {
        type: "group",
        masterIndex,
        subgroupIndex: null,
        target,
        value: target.groupName || "",
      };
      this.$nextTick(() => {
        const el = this.$el.querySelector(".items-inline-edit");
        if (el) el.focus();
      });
    },
    onStartEditGroup({master, masterIndex}) {
      this.startEditGroup(master, masterIndex);
    },
    onCommitEditGroup() {
      const value = (this.editing.value || "").trim();
      if (!this.editing.target) return;
      this.$set(
          this.items[this.editing.masterIndex],
          "groupName",
          value || this.items[this.editing.masterIndex].groupName
      );
      const updated = {...this.items[this.editing.masterIndex]};
      this.editing = {
        type: null,
        masterIndex: null,
        subgroupIndex: null,
        target: null,
        value: "",
      };
      this.postApi({
        url: this.urlCreateUpdateGroup,
        obj: updated,
        notNotifyToast: true,
      }).then(() => {
      });
    },
    startEditSubgroup(target, masterIndex, subgroupIndex) {
      this.editing = {
        type: "subgroup",
        masterIndex,
        subgroupIndex,
        target,
        value: target.groupName || "",
      };
      this.$nextTick(() => {
        const el = this.$el.querySelector(".items-inline-edit");
        if (el) el.focus();
      });
    },
    onStartEditSubgroup({subgroup, masterIndex, subgroupIndex}) {
      this.startEditSubgroup(subgroup, masterIndex, subgroupIndex);
    },
    onCommitEditSubgroup() {
      const value = (this.editing.value || "").trim();
      if (!this.editing.target) return;
      this.$set(
          this.items[this.editing.masterIndex].subGroups[
              this.editing.subgroupIndex
              ],
          "groupName",
          value ||
          this.items[this.editing.masterIndex].subGroups[
              this.editing.subgroupIndex
              ].groupName
      );
      const updated = {
        ...this.items[this.editing.masterIndex].subGroups[
            this.editing.subgroupIndex
            ],
      };
      this.editing = {
        type: null,
        masterIndex: null,
        subgroupIndex: null,
        target: null,
        value: "",
      };
      this.postApi({
        url: this.urlCreateUpdateSubgroup,
        obj: updated,
        notNotifyToast: true,
      }).then(() => {
      });
    },

    onDragEndMasters() {
      (this.items || []).forEach((group, index) => {
        this.$set(group, "groupOrder", index + 1);
        this.ensureKey(group, "g", "groupId");
      });
      this.postApi({
        url: this.urlReorderedGroup,
        obj: this.items,
        notNotifyToast: true,
      }).then(() => {
      });
    },
    onDragEndSubgroups({master, masterIndex}) {
      const masterRef = this.getMasterByKey(master);
      if (!masterRef || !Array.isArray(masterRef.subGroups)) return;
      masterRef.subGroups.forEach((subgroup, index) => {
        this.$set(subgroup, "groupOrder", index + 1);
        this.ensureKey(subgroup, "sg", "groupId");
        this.$set(
            subgroup,
            "groupMasterId",
            masterRef.groupId || masterRef.id || null
        );
      });
      const payload = masterRef.subGroups.map((subgroup) => ({
        groupId: subgroup.groupId || subgroup.id || null,
        groupOrder: subgroup.groupOrder,
        groupMasterId: subgroup.groupMasterId,
      }));
      this.postApi({
        url: this.urlReorderedSubgroup,
        obj: payload,
        notNotifyToast: true,
      }).then(() => {
      });
    },
    onDragChangeProduct({
                          event,
                          master,
                          subgroup,
                          masterIndex,
                          subgroupIndex,
                        }) {
    },
    onDragEndProducts({event, master, subgroup, masterIndex, subgroupIndex}) {
      const toElement = event && event.to ? event.to : null;
      const targetGroupId = toElement
          ? toElement.getAttribute("data-group-id") || null
          : null;

      let targetMasterIndex = masterIndex;
      let targetSubgroupIndex = subgroupIndex;

      if (targetGroupId) {
        for (let i = 0; i < (this.items || []).length; i++) {
          const subgroups = this.items[i]?.subGroups || [];
          const j = subgroups.findIndex(
              (s) => (s.groupId || s.id || null) == targetGroupId
          );
          if (j > -1) {
            targetMasterIndex = i;
            targetSubgroupIndex = j;
            break;
          }
        }
      }

      const productsOrder = (
          this.items[targetMasterIndex].subGroups[targetSubgroupIndex].products ||
          []
      ).map((product, index) => ({
        id: product.id,
        order: index + 1,
        groupId: targetGroupId || subgroup.groupId || subgroup.id || null,
      }));

      this.putApi({
        url: this.urlReorderItemsApi,
        obj: productsOrder,
        notNotifyToast: true,
      }).then(() => {
      });
    },

    async onTemplateChosen(option) {
      this.showTemplateChoice = false;
      if (option === "template") {
        this.setWithoutGroupStructure(false);
        this.showGroupTemplateModal = true;
        return;
      }
      if (option === "without-group") {
        const updated = await this.updateWithoutGroupFlag(true);
        if (!updated) return;
        const groups = this.buildWithoutGroupStructure();
        this.setWithoutGroupStructure(true);
        this.applyGroupsStructure(groups);
        return;
      }
      this.setWithoutGroupStructure(false);
    },
    convertTemplateToDraggableItems(templateObject) {
      if (!templateObject || !templateObject.json) return [];
      let groups;
      try {
        groups =
            typeof templateObject.json === "string"
                ? JSON.parse(templateObject.json)
                : templateObject.json;
      } catch (e) {
        return [];
      }
      if (!Array.isArray(groups)) return [];
      return groups.map((group) => {
        const subgroups = Array.isArray(group.subgroups)
            ? group.subgroups
            : Array.isArray(group.subGroups)
                ? group.subGroups
                : [];
        return {
          groupId: group.groupId || group.id || "",
          groupOrder: group.groupOrder ?? group.order ?? null,
          groupName: group.groupName || group.name || "",
          subGroups: subgroups.map((sub) => ({
            groupId: sub.groupId || sub.id || "",
            groupOrder: sub.groupOrder ?? sub.order ?? null,
            groupName: sub.groupName || sub.name || "",
            products: Array.isArray(sub.products) ? sub.products : [],
          })),
        };
      });
    },
    openCreateTemplateModal() {
      this.showGroupTemplateModal = false;
      this.templateEditItem = null;
      this.$nextTick(() => this.openModal("createTemplateModel"));
    },
    openEditTemplateModal(templateItem) {
      if (!templateItem || !templateItem.id) return;
      this.showGroupTemplateModal = false;
      this.templateEditItem = {
        id: templateItem.id,
        name: templateItem.name || "",
        json: templateItem.json || "[]",
      };
      this.$nextTick(() => this.openModal("createTemplateModel"));
    },
    closeCreateTemplateModal() {
      this.hideModal();
      this.templateEditItem = null;
    },
    onTemplateSaved() {
      this.setWithoutGroupStructure(false);
      this.showGroupTemplateModal = true;
      this.closeCreateTemplateModal();
    },
    buildWithoutGroupStructure() {
      return [
        {
          id: "",
          name: "#",
          order: 1,
          collapsed: false,
          subgroups: [{id: "", name: "#", order: 1, products: []}],
        },
      ];
    },
    ensureWithoutGroupStructureExists() {
      const canCheck =
          this.withoutGroupStructure &&
          this.selectedPeriod &&
          this.selectedPeriod.period &&
          !this.selectedPeriod.showAll;
      if (!canCheck) return;
      const hasStructure = (this.items || []).some((group) => {
        if ((group.groupName || group.name || "").trim() !== "#") return false;
        const subgroups = Array.isArray(group.subGroups)
            ? group.subGroups
            : Array.isArray(group.subgroups)
                ? group.subgroups
                : [];
        return subgroups.some(
            (s) => (s.groupName || s.name || "").trim() === "#"
        );
      });
      if (!hasStructure)
        this.applyGroupsStructure(this.buildWithoutGroupStructure());
    },
    async updateWithoutGroupFlag(enabled) {
      const periodRentId =
          this.selectedPeriod && this.selectedPeriod.period
              ? this.selectedPeriod.period.id
              : "";
      if (!periodRentId) return false;
      try {
        const response = await this.putApi({
          url: this.urlUpdateWithoutGroupSubgroup,
          notNotifyToast: true,
          obj: {
            rentId: this.rent.id,
            periodRentId,
            withoutGroupSubgroup: Boolean(enabled),
          },
        });
        if (!response?.success) return false;
        this.setWithoutGroupStructure(Boolean(enabled));
        return true;
      } catch (e) {
        return false;
      }
    },
    applyGroupsStructure(groups) {
      if (!Array.isArray(groups) || !groups.length) return;
      this.putApi({
        url: this.urlCreateEditOrder,
        obj: {
          periodRentId:
              this.selectedPeriod && this.selectedPeriod.period
                  ? this.selectedPeriod.period.id
                  : null,
          rentId: this.rent.id,
          onlyStock: this.operational,
          groups,
        },
        notNotifyToast: true,
      }).then(() => this.getAll());
    },
    applyTemplate(templateObject) {
      this.showGroupTemplateModal = false;
      this.setWithoutGroupStructure(false);
      if (!templateObject || !templateObject.template) return;
      let groups;
      try {
        groups = JSON.parse(templateObject.template);
      } catch (e) {
        return;
      }
      this.applyGroupsStructure(groups);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "itemRentUpdate") {
          this.modal.component = "edit";
          this.modal.title = event.data.productFullName;
          this.modal.width = 1000;
          this.itemSelected = event.data;
          this.openModal("options");
        }
        if (event.name == "totalizationAndHistory") {
          this.itemSelected = event.data;
          this.modal.component = "statusStock";
          this.modal.title = event.data.productFullName;
          this.modal.width = 850;
          this.openModal("options");
        }
        if (event.name == "timeLineAvailability") {
          this.modal.component = "timeLineAvailability";
          this.modal.title = "Painel";
          this.modal.width = 900;
          this.itemSelected = event.data;
          this.openModal("options");
        }
        if (event.name == "itemsAccessoryList") {
          this.itemSelected = event.data;
          this.kitOrAccessory = "accessory";
          this.showKitOrAccessoryList = true;
        }
        if (event.name == "itemsKitList") {
          this.itemSelected = event.data;
          this.kitOrAccessory = "kit";
          this.showKitOrAccessoryList = true;
        }
        if (event.name == "applyDiscount") {
          this.itemSelected = event.data || {};
          this.openModal("applyDiscount");
        }
        if (event.name == "itemRentDelete") {
          this.itemSelected = event.data || {};
          this.openModal("itemRentDelete");
        }
        if (event.name == "recalculateValue") {
          this.openModal("recalculateValue");
        }
        if (event.name == "changeGroup") {
          this.itemSelected = event.data || {};
          this.showModalGroup = true;
          this.openModal("changeGroup");
        }
        if (event.name == "hideModalSearchProduct") {
          this.getAll();
        }
        if (event.name == "templateSavedFromBuilder") {
          this.onTemplateSaved(event.data || {});
        }
        if (event.name == "templateBuilderBackToList") {
          this.showGroupTemplateModal = true;
          this.closeCreateTemplateModal();
        }
        if (event.name == "withoutGroupSubgroupUpdated") {
          const payload = event.data || {};
          const currentPeriodId =
              this.selectedPeriod && this.selectedPeriod.period
                  ? this.selectedPeriod.period.id
                  : "";
          if (
              payload.rentId === this.rent.id &&
              payload.periodRentId === currentPeriodId
          ) {
            payload.enabled
                ? this.ensureWithoutGroupStructureExists()
                : this.getAll();
          }
        }
        if (
            event.name == "updateTotalizationRent" ||
            event.name == "rentAccepted" ||
            event.name == "rentRejected" ||
            event.name == "itemsImported" ||
            event.name == "actionsUpdated"
        ) {
          this.getAll();
        }
      },
      deep: true,
    },
    showKitOrAccessoryList: {
      handler(value) {
        const deleteAction = this.actions.find((x) => x.type === "delete");
        if (!deleteAction) return;
        deleteAction.url = `/api/v1/rental/items-rent/delete${
            this.operational ? "-operational" : ""
        }${value ? "-kit" : ""}`;
      },
    },
  },
};
</script>

<style scoped>
.items-list-root {
  min-height: 500px;
}

.items-list-main {
  margin-left: 5px;
}

.items-list-loading {
  margin-top: 20px;
}

.items-search-wrap {
  padding: 0 0 12px 0;
}

.items-search-input {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 5px 16px;
  font-size: 13px;
  color: #0f172a;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.items-search-input::placeholder {
  color: #94a3b8;
}

.items-search-input:focus {
  border-color: #cbd5e1;
}
</style>
